import { render } from "./LoadingSpinnerNr8.vue?vue&type=template&id=0cca89a4&scoped=true"
import script from "./LoadingSpinnerNr8.vue?vue&type=script&lang=js"
export * from "./LoadingSpinnerNr8.vue?vue&type=script&lang=js"

import "./LoadingSpinnerNr8.vue?vue&type=style&index=0&id=0cca89a4&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cca89a4"]])

export default __exports__